export var EditDraftsTableColumns = /*#__PURE__*/ function(EditDraftsTableColumns) {
    EditDraftsTableColumns["PrimaryContact"] = "primaryContact";
    EditDraftsTableColumns["Client"] = "client";
    EditDraftsTableColumns["MainSignatory"] = "mainSignatory";
    EditDraftsTableColumns["AdditionalRecipients"] = "additionalRecipients";
    EditDraftsTableColumns["AgreementName"] = "agreementName";
    EditDraftsTableColumns["EffectiveDate"] = "effectiveDate";
    EditDraftsTableColumns["ModifiedBy"] = "modifiedBy";
    EditDraftsTableColumns["LastModified"] = "lastModified";
    EditDraftsTableColumns["ExpirationDate"] = "expirationDate";
    EditDraftsTableColumns["IntroductoryMessage"] = "introductoryMessage";
    EditDraftsTableColumns["TermsOfService"] = "termsOfService";
    EditDraftsTableColumns["AgreementNote"] = "agreementNote";
    EditDraftsTableColumns["AutoApproveAmendments"] = "autoApproveAmendments";
    EditDraftsTableColumns["AutoApproveOutOfScopeCharges"] = "autoApproveOutOfScopeCharges";
    EditDraftsTableColumns["NumberOfDaysUntilPaymentIsDue"] = "numberOfDaysUntilPaymentIsDue";
    EditDraftsTableColumns["PaymentMethodRequiredForSigning"] = "paymentMethodRequiredForSigning";
    EditDraftsTableColumns["CreditCardProcessingFees"] = "cardProcessingFees";
    EditDraftsTableColumns["ManualApprovalOfEachPayment"] = "manualApprovalOfEachPayment";
    return EditDraftsTableColumns;
}({});
export var ColumnSortId = /*#__PURE__*/ function(ColumnSortId) {
    ColumnSortId["PrimaryContact"] = "primaryContact";
    ColumnSortId["Client"] = "client";
    ColumnSortId["MainSignatory"] = "mainSignatory";
    ColumnSortId["AdditionalRecipients"] = "additionalRecipients";
    ColumnSortId["AgreementName"] = "agreementName";
    ColumnSortId["EffectiveDate"] = "effectiveDate";
    ColumnSortId["ModifiedBy"] = "modifiedBy";
    ColumnSortId["LastModified"] = "lastModified";
    ColumnSortId["ExpirationDate"] = "expirationDate";
    ColumnSortId["IntroductoryMessage"] = "introductoryMessage";
    ColumnSortId["TermsOfService"] = "termsOfService";
    ColumnSortId["AgreementNote"] = "agreementNote";
    ColumnSortId["AutoApproveAmendments"] = "autoApproveAmendments";
    ColumnSortId["AutoApproveOutOfScopeCharges"] = "autoApproveOutOfScopeCharges";
    ColumnSortId["NumberOfDaysUntilPaymentIsDue"] = "numberOfDaysUntilPaymentIsDue";
    ColumnSortId["PaymentMethodRequiredForSigning"] = "paymentMethodRequiredForSigning";
    ColumnSortId["CreditCardProcessingFees"] = "creditCardProcessingFees";
    ColumnSortId["ManualApprovalOfEachPayment"] = "manualApprovalOfEachPayment";
    return ColumnSortId;
}({});
